import {Stream} from "@cloudflare/stream-react";
import React, {useState} from 'react';
import styled from 'styled-components';
import {motion, AnimatePresence} from 'framer-motion';
import videos from "../../data/videos.json"


export const MethodsSection = styled.section`
    padding: 80px 20px;
    max-width: 1300px;
    margin: 0 auto;
`;

export const SectionHeader = styled.div`
    text-align: center;
    margin-bottom: 50px;
`;

export const SectionTitle = styled(motion.h2)`
    font-size: clamp(2rem, 3vw, 2.6rem);
    font-weight: 800;
`;

export const MethodsLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: flex-start;

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
    }
`;

export const TextColumn = styled(motion.div)`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Lead = styled(motion.p)`
    font-size: 1.1rem;
    line-height: 1.6;
    color: #333;
    margin-bottom: 30px;
`;

export const ToggleButton = styled(motion.button)`
    background: #c58e50;
    color: #fff;
    font-size: 1rem;
    font-weight: 700;
    padding: 14px 24px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
        background: #a6743f;
    }
`;

export const VideoCard = styled(motion.div)`
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

export const VideoWrap = styled.div`
    position: relative;
    width: 100%;
    padding-top: 56.25%;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
`;

export const VideosWrapper = styled(motion.div)`
    margin-top: 50px;
`;

export const VideosGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-top: 30px;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

const fadeUp = {
    hidden: {opacity: 0, y: 30},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6}}
};

export const VideoTitle = styled.div`
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    padding: 10px 0;
    background: #f9f9f9;
    border-top: 1px solid #eee;
`;

const StyledStream = styled(Stream)`
    width: 100%;
`;

export default function Videos() {
    const [showVideos, setShowVideos] = useState(true);

    return (
        <MethodsSection id="methods">
            <SectionHeader>
                <SectionTitle
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    Методи на монтаж и бързо изпълнение
                </SectionTitle>
            </SectionHeader>

            <MethodsLayout>
                {/* Текст и бутон */}
                <TextColumn
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <Lead>
                        <strong>Хидроизолация за 90 минути:</strong> На дървена (дифузно
                        отворена) основа използвайте площно лепило <strong>W-1</strong> за
                        едностранно „мокро“ залепване – бързо, чисто и икономично.
                        <br/>
                        Ръбове и всички надигащи се зони изпълнявайте с{" "}
                        <strong>контактно лепене</strong> (двустранен слой, изчакване,
                        притискане).
                        <br/>
                        Вижде още техники за работа с ъгли, бордове и инсталация на водосточни елементи като воронки и
                        барбакани.
                    </Lead>

                    <ToggleButton
                        onClick={() => setShowVideos(!showVideos)}
                        whileHover={{scale: 1.05}}
                        whileTap={{scale: 0.95}}
                    >
                        {showVideos ? "Скрий видеата" : "Виж още видео инструкции"}
                    </ToggleButton>
                </TextColumn>

                {/* Първо видео */}
                <VideoCard
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <StyledStream controls src={videos[0].videoId}/>
                </VideoCard>
            </MethodsLayout>

            {/* Останалите видеа */}
            <AnimatePresence>
                {showVideos && (
                    <VideosWrapper
                        initial={{opacity: 0, height: 0}}
                        animate={{opacity: 1, height: "auto"}}
                        exit={{opacity: 0, height: 0}}
                        transition={{duration: 0.5}}
                    >
                        <VideosGrid>
                            {videos.slice(1).map((video, i) => (
                                <VideoCard
                                    key={i}
                                    initial={{opacity: 0, y: 20}}
                                    animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.4, delay: i * 0.1}}
                                >
                                    <StyledStream controls src={video.videoId}/>
                                    <VideoTitle>{video.title}</VideoTitle>
                                </VideoCard>
                            ))}
                        </VideosGrid>
                    </VideosWrapper>
                )}
            </AnimatePresence>
        </MethodsSection>
    );
}
